/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DeleteNoteRequest
 */
export interface DeleteNoteRequest {
  /**
   *
   * @type {string}
   * @memberof DeleteNoteRequest
   */
  noteId: string;
}

/**
 * Check if a given object implements the DeleteNoteRequest interface.
 */
export function instanceOfDeleteNoteRequest(
  value: object,
): value is DeleteNoteRequest {
  if (!("noteId" in value) || value["noteId"] === undefined) return false;
  return true;
}

export function DeleteNoteRequestFromJSON(json: any): DeleteNoteRequest {
  return DeleteNoteRequestFromJSONTyped(json, false);
}

export function DeleteNoteRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): DeleteNoteRequest {
  if (json == null) {
    return json;
  }
  return {
    noteId: json["noteId"],
  };
}

export function DeleteNoteRequestToJSON(json: any): DeleteNoteRequest {
  return DeleteNoteRequestToJSONTyped(json, false);
}

export function DeleteNoteRequestToJSONTyped(
  value?: DeleteNoteRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    noteId: value["noteId"],
  };
}
